import React from "react";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown, message, Space } from "antd";
const onClick = ({ key }) => {
  message.info(`Click on item ${key}`);
};
const items = [
  {
    label: "1st menu item",
    key: "1",
  },
  {
    label: "2nd menu item",
    key: "2",
  },
  {
    label: "3rd menu item",
    key: "3",
  },
];
const DefaultDropDown = () => (
  <div className="bg-[white] border border-1 border-gary-500 p-[10px]">
    <Dropdown
      menu={{
        items,
      }}
      trigger={["click"]}
    >
      <a className="text-black" onClick={(e) => e.preventDefault()}>
        Price Range
        <DownOutlined />
      </a>
    </Dropdown>
  </div>
);
export default DefaultDropDown;
